"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalLink = void 0;
var external_link_1 = require("./external-link");
Object.defineProperty(exports, "ExternalLink", { enumerable: true, get: function () { return external_link_1.ExternalLink; } });
//# sourceMappingURL=index.js.map